// extracted by mini-css-extract-plugin
module.exports = {"stakeTokensWrap":"StakeTokens_stakeTokensWrap__1yQK3","staking":"StakeTokens_staking__2f0Dy","metricList":"StakeTokens_metricList__uq_Wg"};